import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const AdminLogin = () => {
    const [passphrase, setPassphrase] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleLogin = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await axios.post(`${API_URL}/auth/login`, { passphrase });
            const { token } = response.data;

            // Store token safely
            localStorage.setItem('adminToken', token);

            // Navigate to Dashboard
            navigate('/admin/dashboard');
        } catch (err: any) {
            setError(err.response?.data?.message || 'Αποτυχία σύνδεσης. Λανθασμένος κωδικός πρόσβασης.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center bg-gray-50 px-4 pt-20">
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                className="max-w-md w-full glass-panel rounded-2xl p-8 shadow-xl border border-gray-100 bg-white"
            >
                <div className="text-center mb-8">
                    <h2 className="text-3xl font-bold text-gray-900 mb-2">Πύλη Διαχείρισης</h2>
                    <p className="text-gray-600">Εισάγετε τον κωδικό πρόσβασης για να διαχειριστείτε τα προϊόντα.</p>
                </div>

                {error && (
                    <div className="bg-red-50 text-red-600 p-4 rounded-lg text-sm mb-6 border border-red-200">
                        {error}
                    </div>
                )}

                <form onSubmit={handleLogin} className="space-y-6">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                            Κωδικός Πρόσβασης
                        </label>
                        <input
                            type="password"
                            value={passphrase}
                            onChange={(e) => setPassphrase(e.target.value)}
                            className="w-full px-4 py-3 rounded-lg border border-gray-300 focus:ring-2 focus:ring-green-500 focus:border-green-500 outline-none transition-all font-mono"
                            placeholder="Εισάγετε τον κωδικό..."
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        disabled={loading}
                        className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3 px-4 rounded-lg transition-colors flex items-center justify-center disabled:opacity-70"
                    >
                        {loading ? 'Επαλήθευση...' : 'Είσοδος'}
                    </button>
                </form>
            </motion.div>
        </div>
    );
};

export default AdminLogin;
